import { NgModule } from '@angular/core';

import { CommonModule } from "@angular/common";
import { CarbonFootprintComponent } from "./carbon-footprint.component";
import { PermissionModule } from 'libraries/permission/permission.module';
import { LanguageService } from "libraries/service/language/language.service";

@NgModule({
    imports: [
        CommonModule,
        PermissionModule,
    ],
    exports: [
        CarbonFootprintComponent
    ],
    declarations: [CarbonFootprintComponent],
    providers: [LanguageService]
})
export class CarbonFootprintModule {
}
